<div class="summary">
  <div class="modal-header">
    <button
      type="button"
      class="close"
      ng-click="$close()"
    >
      &times;
    </button>
    <div class="text-center">
        <button
          class="btn-white"
          ng-disabled="$ctrl.summaryActive.numeroAplicacao <= 1"
          title="Anterior"
          ng-click="$ctrl.summaryActive = $ctrl.summaries[$ctrl.summaryActive.numeroAplicacao - 2]"
        >
          <i class="fa fa-arrow-left"></i>
        </button>

        <h4 class="modal-title inline">Detalhes da {{$ctrl.summaryActive.numeroAplicacao}}º aplicação</h4>

        <button
          class="btn-white"
          ng-disabled="$ctrl.summaryActive.numeroAplicacao >= $ctrl.summaries.length"
          title="Próximo"
          ng-click="$ctrl.summaryActive = $ctrl.summaries[$ctrl.summaryActive.numeroAplicacao]"
        >
          <i class="fa fa-arrow-right"></i>
        </button>

    </div>
  </div>
  <div class="modal-body">
    <div class="row">
      <table class="table">
        <thead>
          <th>Talhão</th>
          <th ng-if="$ctrl.summaryActive.numeroAplicacao === 1">Dias entre emergência e 1ª aplicação</th>
          <th>Dias entre aplicações</th>
          <th>Posição no ciclo</th>
          <th>Recomendado</th>
          <th>Aplicado</th>
          <th>Diferença recomendado/aplicado</th>
        </thead>
        <tbody>
          <tr ng-repeat="parameter in $ctrl.summaryActive.parameters">
            <td>{{parameter.gleba.descricao}}</td>
            <td ng-if="$ctrl.summaryActive.numeroAplicacao === 1"> {{parameter.diasEntreEmergenciaEAplicacao}}</td>
            <td>{{parameter.dias_intervalo}}</td>
            <td>{{parameter.posicaoCiclo}}</td>
            <td>{{parameter.recomendacao.data_inicio | date: 'dd/MM/yyyy'}}</td>
            <td>{{parameter.data_fim_aplicacao | date: 'dd/MM/yyyy'}}</td>
            <td>
              {{parameter.difDateAplicacaoRecomendacao}}
              <span ng-if="parameter.difDateAplicacaoRecomendacao">Dias</span>
            </td>
          </tr>
          <tr class="row-media" ng-if="$ctrl.summaryActive.parameters.length > 1">
            <td><b>Média</b></td>
            <td ng-if="$ctrl.summaryActive.numeroAplicacao === 1"></td>
            <td>{{$ctrl.summaryActive.average.diasIntervalo | number:2}}</td>
            <td>{{$ctrl.summaryActive.average.posicaoCiclo | number:2}}</td>
            <td></td>
            <td></td>
            <td>
              {{$ctrl.summaryActive.average.difDateAplicacaoRecomendacao | number:2}}
              <span ng-if="$ctrl.summaryActive.average.difDateAplicacaoRecomendacao">Dias</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
